import { firebase } from 'firebase-config';
import { getDocument } from 'utils';

const loginActions = {
  SIGN_IN: 'SIGN_IN',
  SIGN_IN_ERROR: 'SIGN_IN_ERROR',

  SET_IS_ADMIN: 'SET_IS_ADMIN',
  SET_IS_ADMIN_SUCCESS: 'SET_IS_ADMIN_SUCCESS',
  SET_IS_ADMIN_ERROR: 'SET_IS_ADMIN_ERROR',

  RESET_ERROR: 'RESET_ERROR',
  RESET_SUCCESS: 'SET_SUCCESS',

  signIn: ({ email, password }) => (dispatch) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(async (data) => {
        const curentUser = await getDocument(data.user.uid, 'users');
        const isAdmin = curentUser && curentUser.admin;
        if (isAdmin) {
          dispatch({ type: loginActions.SET_IS_ADMIN_SUCCESS, payload: 'SET_IS_ADMIN_SUCCESS' });
        } else {
          dispatch({ type: loginActions.SET_IS_ADMIN_ERROR, payload: 'SET_IS_ADMIN_ERROR' });
        }
        dispatch({ type: loginActions.SET_IS_ADMIN, payload: isAdmin });
      })
      .catch((error) => dispatch({ type: loginActions.SIGN_IN_ERROR, payload: error.message }));
  },

  checkIsAdmin: (userId) => (dispatch) => () => {
    const curentUser = getDocument(userId, 'users');
    const isAdmin = curentUser && curentUser.admin;
    if (isAdmin) {
      dispatch({ type: loginActions.SET_IS_ADMIN_SUCCESS, payload: 'SET_IS_ADMIN_SUCCESS' });
    } else {
      dispatch({ type: loginActions.SET_IS_ADMIN_ERROR, payload: 'SET_IS_ADMIN_ERROR' });
    }
    dispatch({ type: loginActions.SET_IS_ADMIN, payload: isAdmin });
  },
  resetError: () => (dispatch) => dispatch({ type: loginActions.RESET_ERROR, payload: null }),
  resetSuccess: () => (dispatch) => dispatch({ type: loginActions.RESET_SUCCESS, payload: null })
};

export default loginActions;
